import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import { Decomposition } from "../debt-table"
import * as DebtUtils from "../utils"
import { ReportConfiguration } from "../../../configuration"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
	getPlaceholderBodyOptions,
	Placeholder
} from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import { LoanWithDecomposition } from "../../../../../model"

export function checkRemainingCapitalSection(
	configuration: ReportConfiguration
): boolean {
	const remainingCapital = configuration.debt.remainingCapital
	return remainingCapital.globalCharts
	|| remainingCapital.perBank
	|| remainingCapital.perRateType
	|| remainingCapital.tables
}

export function createRemainingCapitalSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	childDecomposedLoans: any,
	years: number[],
	checked:any
): DocumentSection {
	const slides: Slide[] = []
	const slidesTitle = formatTitle("Capital restant dû", numbering)
	const remainingCapital = configuration.debt.remainingCapital
	const placeholderBody = getPlaceholderBodyOptions()
	const baseColor = new Color(configuration.table.header.backgroundColor)

		DebtUtils.includeDebtTable(
			pptx,
			slidesTitle,
			"management-report-debt-remaining-capital",
			Decomposition.RemainingCapital,
			childDecomposedLoans,
			years,
			configuration,
			checked
		)


	return { slides, title: slidesTitle }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/remaining-capital-generator/index.tsx